import { useQuery } from '@tanstack/react-query';
import { InferResponseType, useFanforgeApi } from '@hotpot-arcade/fanforge-api-client';
import { hc } from 'hono/client';
import { AppType } from '@hotpot-arcade/fanforge-api';

const apiStub = hc<AppType>('');
const getUsersApi = apiStub.users[':userId'].$get;
export type UserData = InferResponseType<typeof getUsersApi, 200>;

export const useUserData = (userId: string) => {
  const { client: apiClient } = useFanforgeApi();

  const { data } = useQuery({
    queryKey: [userId],
    queryFn: async (): Promise<UserData | null> => {
      const response = await apiClient.users[':userId'].$get({
        param: {
          userId: userId,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch leaderboard: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    },
    enabled: !!userId,
  });

  return data;
};
